import "./App.scss";
import Home from "./Home";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NavBar from "./components/NavBar";
import Details from "./Details";
import Footer from "./components/Footer";

const App = () => (
	<Router className="App">
		<NavBar />
		<Routes>
			<Route path="/">
				<Route index element={<Home />} />
				<Route path="/events">
					<Route index element={<Details />} />
					<Route path=":eventname" element={<Details />} />
				</Route>
			</Route>
		</Routes>
		<Footer />
	</Router>
);
export default App;
